export enum SubscriptionTierEnum {
  NONE,
  CORE,
  SIMS_BASIC,
  SIMS_MAX,
  MVP  // Highest tier - full access to all pool sizes
}